import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Data from "../../assets/data/data";
import { FaPlus, FaMinus } from "react-icons/fa6";

const SubTypes = () => {
  const { types } = useParams();
  const [openAccordions, setOpenAccordions] = useState(new Set());
  const [menuData, setMenuData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    try {
      const menuArray = Data.find((item) => item.menu)?.menu || [];
      const foundMenu = menuArray.find((menuItem) => menuItem.type === types);
      if (foundMenu) {
        setMenuData(foundMenu);
        setError(null);
        const allKeys = Object.keys(foundMenu.items || {});
        setOpenAccordions(new Set(allKeys));
      } else {
        setError("Menu type not found");
      }
    } catch (error) {
      setError("Failed to load menu data");
    }
  }, [types]);

  const toggleAccordion = (key) => {
    setOpenAccordions((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(key)) {
        newSet.delete(key);
      } else {
        newSet.add(key);
      }
      return newSet;
    });
  };

  const isAccordionOpen = (key) => {
    return openAccordions.has(key);
  };

  if (error) {
    return (
      <div className="py-14 px-5 sm:px-14 md:px-16 lg:px-20 text-center">
        <p className="text-red-500">{error}</p>
        <button
          onClick={() => window.location.reload()}
          className="mt-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
        >
          Retry
        </button>
      </div>
    );
  }

  if (!menuData) {
    return (
      <div className="py-14 px-5 sm:px-14 md:px-16 lg:px-20 text-center">
        <p>Loading menu...</p>
      </div>
    );
  }

  const formatKey = (key) => key.replace(/([A-Z])/g, " $1").trim();

  return (
    <section className="py-14 px-5 sm:px-14 md:px-16 lg:px-20">
      {menuData.cover_image && (
        <div className="flex justify-center mb-8">
          <img src={menuData.cover_image} alt="cover" className="max-h-80" />
        </div>
      )}
      <div className="text-center mb-8">
        <div className="font-extrabold text-3xl capitalize">
          {menuData.title || types}
        </div>
      </div>

      <div className="space-y-4 max-w-4xl mx-auto">
        {menuData.items &&
          Object.keys(menuData.items).map((categoryKey) => {
            const categoryItems = menuData.items[categoryKey];
            const isOpen = isAccordionOpen(categoryKey);

            return (
              <div
                key={categoryKey}
                className="bg-gray-100 rounded-lg shadow-sm"
              >
                <div className="bg-gray-200 rounded-lg p-4">
                  <div className="flex justify-between items-center">
                    <div className="font-medium text-lg capitalize">
                      {formatKey(categoryKey)}
                    </div>
                    <button
                      onClick={() => toggleAccordion(categoryKey)}
                      className="text-gray-600 hover:text-gray-800"
                    >
                      {isOpen ? <FaMinus /> : <FaPlus />}
                    </button>
                  </div>

                  {isOpen && (
                    <div className="mt-4 p-4 bg-white border border-gray-300 rounded">
                      {Array.isArray(categoryItems) ? (
                        <ul className="space-y-2">
                          {categoryItems.map((item, idx) => (
                            <li
                              key={idx}
                              className="flex justify-around items-center border-b border-b-slate-300"
                            >
                              <div className="w-4/6">
                                <strong>{item.name}</strong>
                              </div>

                              <div className="w-4/6">
                                <span className="ml-2">
                                  {item.description || "-"}
                                </span>
                              </div>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        Object.keys(categoryItems).map((subKey) => (
                          <div key={subKey} className="mb-4">
                            <div className="font-semibold text-red-600 capitalize mb-2">
                              {formatKey(subKey)}
                            </div>
                            <ul className="space-y-2">
                              {categoryItems[subKey].map((item, idx) => (
                                <li
                                  key={idx}
                                  className="flex justify-between items-center border-b border-b-slate-300"
                                >
                                  <div className="w-4/6">
                                    <strong>{item.name}</strong>
                                  </div>

                                  <div className="w-4/6">
                                    <span className="ml-2">
                                      {item.description || "-"}
                                    </span>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          </div>
                        ))
                      )}
                    </div>
                  )}
                </div>
              </div>
            );
          })}

        {Object.keys(menuData.items).length === 0 && (
          <p className="text-center text-gray-500">
            No items found for this category.
          </p>
        )}
      </div>
    </section>
  );
};

export default SubTypes;
